var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-frame'),_vm._v(" "),_c('first-menu'),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.lawData)}})]),_vm._v(" "),_c('footer-frame')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c692f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/content/Law.vue
// module id = null
// module chunks = 